<template>
  <div class="saveBottom">
    <ul class="save">
      <li class="save-item" v-for="(item, index) in saveList" :key="index">
        <img :src="item.image" alt="item.name" />
        <span>{{ item.name }}</span>
      </li>
    </ul>
    <div class="info" v-if="isMaxScreen">
      <div class="infos">
        <div class="phone-info">
          <div class="info-text">
            <p>
              <span>服务热线：</span>
            </p>
            <span class="phone">400-682-8800</span>
          </div>
        </div>
        <div class="phone-info">
          <div class="info-text">
            <p>
              <span>服务时间：</span>
            </p>
            <span class="phone">周一至周日：9:00-21:00</span>
          </div>
        </div>
        <div class="phone-info">
          <div class="info-text">
            <span class="top">公司地址：</span>
            <span class="phone">
              {{ address }}
            </span>
          </div>
        </div>
        <div class="button-wrappr">
          <div class="button" @click="openUrl(serviceUrl)">
            <img src="../../assets/image/saveBottom/icon_kefu.png" alt="" />
            <span>在线客服</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 移动端 -->
    <div v-else class="info">
      <div class="infos">
        <div class="infos-contact">联系我们</div>
        <div class="phone-info">
          <div class="info-text">
            <span class="hotService">服务热线：</span>
            <span class="phone">400-682-8800</span>
          </div>
        </div>
        <div class="phone-info">
          <div class="service-text">
            <span class="hotService">在线客服：</span>
            <div class="button" @click="openUrl(serviceUrl)">
              <img src="../../assets/image/saveBottom/icon_kefu.png" alt="" />
              <span style="">联系客服</span>
            </div>
          </div>
        </div>
        <div class="phone-info">
          <div class="info-text">
            <span class="hotService">服务时间：</span>
            <span class="phone">周一至周日：9:00-21:00</span>
          </div>
        </div>

        <div class="phone-info">
          <div class="info-text">
            <span class="hotService">公司地址：</span>
            <span class="phone"
              >{{ address }}</span
            >
          </div>
        </div>
      </div>
    </div>
    <div class="record" v-if="isMaxScreen">
      <span @click="openUrl(icpUrl)"
        >互联网ICP备案/许可证号：{{ recordNumber }}</span
      >
      <span>Copyright © 2020 - 2021 {{ name }}市当换网络科技有限公司</span>
      <span class="record-police" @click="openUrl(policeUrl)">
        <img
          src="../../assets/image/saveBottom/gonganbeian.png"
          alt="公网安备"
        />
        {{ number }}</span
      >
      <span @click="handleQualify">资质证照</span>
    </div>

    <!-- 移动端 -->
    <div v-else class="record">
      <span @click="openUrl(icpUrl)"
        >互联网ICP备案/许可证号：{{ recordNumber }}</span
      >
      <span>Copyright © 2020 - 2021 {{ name }}市当换网络科技有限公司</span>
      <span class="record-police" @click="openUrl(policeUrl)">
        <img
          src="../../assets/image/saveBottom/gonganbeianMoblie.png"
          alt="公网安备"
        />
        {{ number }}</span
      >
      <span @click="handleQualify">资质证照</span>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data() {
    return {
      saveList: [
        {
          image: require('../../assets/image/saveBottom/icon_tiexin.png'),
          name: '贴心'
        },
        {
          image: require('../../assets/image/saveBottom/icon_anquan.png'),
          name: '安全'
        },
        {
          image: require('../../assets/image/saveBottom/icon_bianjie.png'),
          name: '便捷'
        },
        {
          image: require('../../assets/image/saveBottom/icon_zhaunye.png'),
          name: '专业'
        }
      ],
      // 在线客服
      serviceUrl:
        'https://danghuan.soboten.com/chat/pc/v2/index.html?sysnum=f922b6afde874f19be95ff5a0a31f9f6&channelid=2',
      // 互联网备案许可
      icpUrl: 'https://beian.miit.gov.cn',
      // 公安备案
      policeUrl:
        'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44190002004932',
      address: '广东省深圳市南山区粤兴六道中科纳能大厦 A 座 5 楼',
      recordNumber: '粤ICP备 2020104649 号',
      number: '粤公网安备 44190002004932号',
      name: '深圳'
    }
  },
  computed: {
    ...mapState({
      isMaxScreen: (state) => {
        return state.isMaxScreen
      }
    })
  },
  created () {
    const list = ['cqdanghuan.com', 'cqdh']
    let flag = false
    list.forEach(item => {
      if (window.location.origin.indexOf(item) > -1) {
        flag = true
      }
    })
    if (flag) {
      document.title = '当换官网-重庆市当换网络科技有限公司官方网站 | 以旧换新 | 手机回收 | 二手优品 | 笔记本回收 |专业回收 | 二手数码服务商'
      this.name = '重庆'
      this.address = '重庆市渝北区玉峰山镇玉龙大道188号'
      this.recordNumber = '渝ICP备 2021011981 号'
      this.number = '渝公网安备 50011202503216号'
      this.policeUrl = 'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=50011202503216'
    }
  },
  methods: {
    // 跳转外部链接
    openUrl(url) {
      window.open(url)
    },
    /**
     * 思路：先跳转home 将元素全部删除，然后将img放入，最后更改title
     */
    // handleQualify() {
    //   const imageWindow = window.open(window.location.href)
    //   const img = imageWindow.document.createElement('img')
    //   img.src = require('../../assets/image/saveBottom/zzzz.png')
    //   img.style = 'width:100%'
    //   setTimeout(() => {
    //     const parentNode = imageWindow.document.getElementById('app')
    //     parentNode.innerHTML = ''
    //     imageWindow.document.getElementsByTagName('body')[0].appendChild(img)
    //     imageWindow.document.title = '资格证照'
    //   }, 400)
    // },
    handleQualify() {
      // const img = window.document.createElement('img')
      // img.src = require('../../assets/image/saveBottom/zzzz.png')
      // img.style = 'width:100%'
      // setTimeout(() => {
      //   const parentNode = window.document.getElementById('app')
      //   parentNode.innerHTML = ''
      //   window.document.getElementsByTagName('body')[0].appendChild(img)
      // }, 400)
      const { href } = this.$router.resolve({ path: '/qualify' })
      // let imageWindow = null
      // if (this.isMaxScreen) {
      window.open(href, '_blank')
      // } else {
      // imageWindow = window.open(href, '_self', 'fullscreen=yes', true)
      //   this.$router.push('/qualify')
      // }
      // setTimeout(() => {
      //   imageWindow.document.title = '资格证照'
      // }, 200)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@media (max-width: 980px) {
  .saveBottom {
    background: #f2f5f8;
    .save {
      width: 100%;
      height: 100px;
      background: #272727;
      padding: 0;
      margin: 0;
      list-style: none;
      display: flex;
      justify-content: center;
      .save-item {
        flex: 1;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 42px;
          height: 42px;
          margin-right: 8px;
        }
        span {
          color: white;
          font-size: 26px;
        }
      }
    }
    .info {
      padding: 0 24px;
      box-sizing: border-box;

      .infos {
        padding-top: 10px;
        box-sizing: border-box;
        position: relative;
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        .infos-contact {
          display: flex;
          align-items: center;
          height: 80px;
          font-size: 28px;
          font-family: SourceHanSansCN-Medium, SourceHanSansCN;
          font-weight: 500;
          color: #333333;
          line-height: 42px;
        }
        .phone-info {
          width: 100%;
          height: 68px;
          display: flex;
          align-items: center;
          box-sizing: border-box;
          img {
            width: 24px;
            height: 24px;
            margin: 4px 14px 0 0;
          }
          .info-text {
            display: flex;
            align-items: center;
            span {
              font-size: 24px;
              line-height: 24px;
              line-height: 30px;
              color: #666;
            }
            .hotService {
              font-size: 24px;
              font-family: SourceHanSansCN-Regular, SourceHanSansCN;
              font-weight: 400;
              color: #666666;
              line-height: 36px;
            }
            .phone {
              font-size: 24px;
              font-family: SourceHanSansCN-Regular, SourceHanSansCN;
              font-weight: 400;
              color: #111111;
              line-height: 36px;
            }
            .top {
              margin-bottom: 22px;
              margin-top: 4px;
              font-size: 24px;
              color: #111;
            }
            .address {
              color: #666;
              font-size: 24px;
              font-weight: normal;
            }
          }
          .service-text {
            height: 68px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            .hotService {
              margin-right: 16px;
              font-size: 24px;
              font-family: SourceHanSansCN-Regular, SourceHanSansCN;
              font-weight: 400;
              color: #666666;
              line-height: 36px;
            }
            .button {
              height: 60px;
              padding: 0 25px;
              background: #ff9600;
              border-radius: 40px;
              display: flex;
              align-items: center;
              font-size: 24px;
              img {
                width: 28px;
                height: 28px;
                margin: 0 6px 0 0;
              }
              span {
                font-family: SourceHanSansCN-Regular, SourceHanSansCN;
                font-weight: 400;
                color: #ffffff;
                margin: 0;
              }
            }
          }
        }
        .phone-info:last-child {
          margin-bottom: 20px;
        }
      }
    }
    .record {
      width: 100%;
      padding: 20px 0;
      box-sizing: border-box;
      span {
        display: block;
        height: 24px;
        margin-bottom: 30px;
        font-size: 24px;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #999999;
        line-height: 36px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      span:last-child {
        margin-bottom: 0;
      }
      .record-police > img {
        width: 24px;
        height: 24px;
        vertical-align: -15%;
        margin-right: 5px;
      }
    }
    @supports (bottom: env(safe-area-inset-bottom)) or
      (bottom: constant(safe-area-inset-bottom)) {
      .record {
        margin-bottom: env(safe-area-inset-bottom);
        margin-bottom: constant(safe-area-inset-bottom);
      }
    }
  }
}
@media (min-width: 981px) {
  .saveBottom {
    display: flex;
    flex-direction: column;
    align-items: center;
    background: white;
    .save {
      width: 100%;
      height: 180PX;
      background: #272727;
      padding: 0;
      margin: 0;
      list-style: none;
      display: flex;
      justify-content: center;
      .save-item {
        width: 300PX;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 42PX;
          height: 42PX;
          margin-right: 8PX;
        }
        span {
          color: white;
          font-size: 26PX;
        }
      }
    }
    .info {
      width: 1200PX;
      padding: 37PX 0;
      display: flex;
      border-bottom: 1PX solid rgba(0, 0, 0, 0.1);
      box-sizing: border-box;
      .infos {
        width: 100%;
        box-sizing: border-box;
        display: flex;
        align-items: center;

        .phone-info {
          display: flex;
          align-items: flex-start;
          margin-right: 60PX;
          .info-text {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            span {
              font-size: 16PX;
              font-family: SourceHanSansCN-Regular, SourceHanSansCN;
              font-weight: 400;
              color: #777777;
              line-height: 24PX;
            }
            .phone {
              margin-top: 28PX;
              font-family: SourceHanSansCN-Regular, SourceHanSansCN;
              font-weight: 400;
              color: #333333;
              line-height: 24PX;
            }
          }
        }

        .button-wrappr {
          display: flex;
          justify-content: flex-end;
          align-items: center;
          flex: 1;
          .button {
            // width: 204PX;
            height: 60PX;
            color: white;
            background: #ff9600;
            border-radius: 35PX;
            display: flex;
            align-items: center;
            cursor: pointer;
            font-size: 22PX;
            // box-sizing: content-box;
            padding: 0 35PX;
            img {
              width: 40PX;
              height: 40PX;
              margin-right: 7PX;
            }
          }
        }
      }
    }
    .record {
      width: 1200PX;
      padding: 24PX 0;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      // text-align: center;
      // line-height: 60PX;
      font-size: 12PX;
      color: #999;
      span {
        cursor: pointer;
        border-right: 1PX solid rgba(0, 0, 0, 0.1);
        padding: 0 20PX;
      }
      span:first-child {
        padding-left: 0;
      }
      span:nth-child(2) {
        cursor: default;
      }
      span:last-child {
        border-right: none;
      }
      .record-police {
        display: flex !important;
        align-items: center;
      }
      .record-police > img {
        width: 16PX;
        height: 16PX;
        vertical-align: -20%;
        margin-right: 5PX;
      }
    }
  }
}
</style>
